import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const ListingManagementPanel = () => {
  const [activeSubTab, setActiveSubTab] = useState('listings');

  const subTabs = [
    { id: 'listings', label: 'All Listings', icon: 'List' },
    { id: 'pending', label: 'Pending Approval', icon: 'Clock' },
    { id: 'featured', label: 'Featured', icon: 'Star' }
  ];

  const mockListings = [
    { id: 1, title: 'Rajesh Photography Studio', vendor: 'Rajesh Kumar', category: 'Photography', status: 'approved', featured: true, views: 1245 },
    { id: 2, title: 'Elegant Wedding Venues', vendor: 'Priya Sharma', category: 'Venues', status: 'pending', featured: false, views: 567 },
    { id: 3, title: 'Mehndi by Priya', vendor: 'Priya Mehndi', category: 'Mehndi', status: 'approved', featured: false, views: 892 },
    { id: 4, title: 'Wedding Planners Pro', vendor: 'Amit Singh', category: 'Planning', status: 'rejected', featured: false, views: 234 }
  ];

  const renderSubTabContent = () => {
    switch (activeSubTab) {
      case 'listings':
        return (
          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-soft p-6">
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">
                <h3 className="font-heading font-semibold text-lg text-text-primary">
                  All Listings
                </h3>
                <Button variant="primary" iconName="Plus" iconSize={16}>
                  Add Listing
                </Button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                <Input placeholder="Search listings..." icon="Search" />
                <select className="px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500">
                  <option>All Categories</option>
                  <option>Photography</option>
                  <option>Venues</option>
                  <option>Mehndi</option>
                  <option>Planning</option>
                </select>
                <select className="px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500">
                  <option>All Status</option>
                  <option>Approved</option>
                  <option>Pending</option>
                  <option>Rejected</option>
                </select>
                <select className="px-4 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500">
                  <option>All Types</option>
                  <option>Featured</option>
                  <option>Regular</option>
                </select>
              </div>

              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-surface-100">
                    <tr>
                      <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase">
                        Listing
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase">
                        Vendor
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase">
                        Category
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase">
                        Status
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase">
                        Views
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-border">
                    {mockListings.map((listing) => (
                      <tr key={listing.id} className="hover:bg-surface-50">
                        <td className="px-4 py-3">
                          <div className="flex items-center">
                            <div className="w-8 h-8 bg-primary-100 rounded-lg flex items-center justify-center mr-3">
                              <Icon name="Store" size={16} className="text-primary" />
                            </div>
                            <div>
                              <span className="font-medium text-text-primary">{listing.title}</span>
                              {listing.featured && (
                                <Icon name="Star" size={14} className="text-warning ml-2" />
                              )}
                            </div>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-text-secondary">{listing.vendor}</td>
                        <td className="px-4 py-3 text-text-secondary">{listing.category}</td>
                        <td className="px-4 py-3">
                          <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${
                            listing.status === 'approved' ? 'bg-success-100 text-success' : 
                            listing.status === 'pending'? 'bg-warning-100 text-warning' : 'bg-red-100 text-red-600'
                          }`}>
                            {listing.status}
                          </span>
                        </td>
                        <td className="px-4 py-3 text-text-secondary">{listing.views}</td>
                        <td className="px-4 py-3">
                          <div className="flex items-center space-x-2">
                            <button className="text-primary hover:text-primary-600">
                              <Icon name="Edit" size={16} />
                            </button>
                            <button className="text-gray-500 hover:text-gray-700">
                              <Icon name="Eye" size={16} />
                            </button>
                            <button className="text-red-500 hover:text-red-700">
                              <Icon name="Trash2" size={16} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        );
      case 'pending':
        return (
          <div className="bg-white rounded-xl shadow-soft p-6">
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-warning-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Clock" size={32} className="text-warning" />
              </div>
              <h3 className="font-heading font-semibold text-xl text-text-primary mb-2">
                Pending Approvals
              </h3>
              <p className="text-text-secondary mb-6">
                Review and approve vendor listings awaiting approval
              </p>
              <Button variant="outline" disabled>
                View Pending
              </Button>
            </div>
          </div>
        );
      case 'featured':
        return (
          <div className="bg-white rounded-xl shadow-soft p-6">
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-warning-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Icon name="Star" size={32} className="text-warning" />
              </div>
              <h3 className="font-heading font-semibold text-xl text-text-primary mb-2">
                Featured Listings
              </h3>
              <p className="text-text-secondary mb-6">
                Manage featured listings and promotion settings
              </p>
              <Button variant="outline" disabled>
                Manage Featured
              </Button>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-gradient-to-r from-primary to-secondary rounded-xl p-6 text-white">
        <h2 className="font-heading font-bold text-2xl mb-2">
          Listing Management
        </h2>
        <p className="text-white/90">
          Manage vendor listings and approvals
        </p>
      </div>

      {/* Sub Navigation */}
      <div className="bg-white rounded-xl shadow-soft p-6">
        <div className="flex flex-wrap gap-2">
          {subTabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveSubTab(tab.id)}
              className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-colors ${
                activeSubTab === tab.id
                  ? 'bg-primary text-white' :'text-text-secondary hover:bg-surface-100'
              }`}
            >
              <Icon name={tab.icon} size={16} />
              <span className="font-medium">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Sub Tab Content */}
      {renderSubTabContent()}
    </div>
  );
};

export default ListingManagementPanel;